export function limitText(text = '', limit) {
    return text.length > limit ? `${text.slice(0, limit).trim()}...` : text.trim();
}

export function capitalizeText(str = '') {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function convertPaymentText(str) {
    return str
        .split('_') // Split the string by underscores
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(' '); // Join the words with a space
}

export function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .normalize('NFD') // Normalize accents
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
        .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric characters except spaces and hyphens
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-'); // Remove multiple hyphens
}

export function safeSlice(str, limit) {
    // Match characters including surrogate pairs (emojis, special symbols)
    const chars = [...str]; // Uses spread to handle Unicode properly
    return chars.slice(0, limit).join('');
}
